var _effectorFileName = "/builds/gmini/front-common/src/Explorer/hooks/usePersist.tsx";
import "regenerator-runtime/runtime.js";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import React from 'react';
import { isNotEmpty } from '@gmini/utils';
import { filterNotExistingActive, fromRefs } from '@gmini/ui-kit';
import { saveToPersist, getFromPersist, loadNodes } from "../Model/tree.persist";
import { fromEntityTreeData } from "../Model";
import { fromNodeRefsToExplorerRefs } from "../Explorer";
export function usePersist(_ref) {
  var key = _ref.key,
      tree = _ref.tree,
      fetchChildren = _ref.fetchChildren;
  var toPersist = React.useCallback(function (_ref2) {
    var activeItemRefs = _ref2.activeItemRefs;
    var toSaveData = fromRefs(tree, activeItemRefs).map(function (_ref3) {
      var payload = _ref3.payload;

      if (payload.type === 'Category') {
        return {
          id: payload.id,
          type: payload.type
        };
      }
    }).filter(isNotEmpty); // Не записываем пустые значения

    if (toSaveData.length) {
      saveToPersist({
        key: key,
        nodes: toSaveData
      });
    }
  }, [key, tree]);
  var initTree = React.useCallback( /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(tree$) {
      var fromPersist, rootNode, explorerTree, actual;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              fromPersist = getFromPersist(key);
              _context.next = 3;
              return loadNodes({
                nodes: fromPersist,
                fetchChildren: fetchChildren
              });

            case 3:
              rootNode = {
                type: 'Root',
                id: 'root',
                title: 'Проводник',
                children: tree$.getState(),
                parentNode: null
              };
              explorerTree = fromEntityTreeData({
                source: rootNode.children,
                parentNode: rootNode
              });
              actual = filterNotExistingActive(explorerTree, fromNodeRefsToExplorerRefs(fromPersist));
              return _context.abrupt("return", actual);

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref4.apply(this, arguments);
    };
  }(), [fetchChildren, key]);
  return React.useMemo(function () {
    return {
      toPersist: toPersist,
      initTree: initTree
    };
  }, [toPersist, initTree]);
}